const ExportIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" {...props} className={`fill-current ${props?.className ? props?.className : ''}`} xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 15.8334H17.5V17.5001H2.5V15.8334ZM10.8333 10.9767L15.8925 5.91675L17.0708 7.09508L10 14.1667L2.92917 7.09591L4.1075 5.91675L9.16667 10.9751V1.66675H10.8333V10.9767Z"/>
  </svg>
);

export default ExportIcon;
